import type { PollService } from "@busbud/core-types";
import type { TripLeg } from "@busbud/int-schemas/udm";

import type { NapiV2CartTrip } from "@app/types/napi-v2-cart-types";
import type { SearchInfo } from "@app/types/search-types";

import { isReturn } from "../search";

export const OUTBOUND_LEG_ID = 1;
export const RETURN_LEG_ID = 2;

export function getSearchedLeg(
  search: SearchInfo,
  trip: PollService.API.RelatedPublicTrip | PollService.API.RelatedPublicTripV4
): PollService.API.PublicTripLeg {
  return isReturn(search) ? getReturnLeg(trip) : getOutboundLeg(trip);
}

export function getLegByDirection(
  trip: PollService.API.RelatedPublicTrip | PollService.API.RelatedPublicTripV4,
  direction: "outbound" | "return"
) {
  return direction === "return" ? getReturnLeg(trip) : getOutboundLeg(trip);
}

export function isOutboundLeg(leg_nb: number) {
  return leg_nb === OUTBOUND_LEG_ID;
}

export function isReturnLeg(leg_nb: number) {
  return leg_nb === RETURN_LEG_ID;
}

export function getOutboundLeg(
  trip: PollService.API.RelatedPublicTrip | PollService.API.RelatedPublicTripV4
): PollService.API.PublicTripLeg {
  const outbound_leg = trip?.trip_legs?.find(trip_leg =>
    isOutboundLeg(trip_leg.leg)
  );
  if (!outbound_leg) {
    throw new Error("Outbound leg not found");
  }

  return outbound_leg;
}

export function getReturnLeg(
  trip: PollService.API.RelatedPublicTrip | PollService.API.RelatedPublicTripV4
): PollService.API.PublicTripLeg {
  const return_leg = trip.trip_legs?.find(trip_leg =>
    isReturnLeg(trip_leg.leg)
  );
  if (!return_leg) {
    throw new Error("Return leg not found");
  }

  return return_leg;
}

export function getReturnLegIfExist(
  trip:
    | PollService.API.RelatedPublicTrip
    | PollService.API.RelatedPublicTripV4
    | NapiV2CartTrip
): PollService.API.PublicTripLeg | Omit<TripLeg, "segment_xids"> | undefined {
  return trip.trip_legs.find(trip_leg => isReturnLeg(trip_leg.leg));
}
